import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { Message } from "../../../@types/message";
import axiosInstance from "../../../utils/axiosConfig";

export const addDocumentHistory = createAsyncThunk(
  "documentUpdate/addDocumentHistory",
  async (messageText: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const userId = state.userAuthentication.user?.id;
      const documentId = state.documentShow.document.id;

      const { data } = await axiosInstance.post(`${api.baseURL}message`, {
        module: "document",
        createdBy: userId,
        document: documentId,
        room: documentId,
        text: messageText,
      });
      return data as Message;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
